import React from 'react';
import { IconButton } from 'components';
import { ArrowDown, ArrowUp } from 'icons';

interface ToggleButtonProps {
  onClick?: () => void;
  isToggled?: boolean;
}

export const ToggleButton = ({
  isToggled = false,
  onClick,
}: ToggleButtonProps) => {
  return (
    <IconButton
      icon={isToggled ? <ArrowUp /> : <ArrowDown />}
      size='small'
      variant='outlined'
      onClick={onClick}
      rounded={false}
    />
  );
};
